import './Loader.css'
import logo from '../../../assets/newdesign/Logo.svg'

const Loader = ({ isExiting }) => {
  return (
    <div
      className={`loader${isExiting ? ' loader--exit' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="loader__mark">
        <img src={logo} alt="" className="loader__logo loader__logo--empty" />
        <div className="loader__logo-fill">
          <img src={logo} alt="" className="loader__logo" />
        </div>
      </div>
    </div>
  )
}

export default Loader
